// extracted by mini-css-extract-plugin
export default {"card":"yJblMCT3QJCFaBmkKPg0","divider":"NTYbRvgFdMVw1fLdivud","skeletonLink":"vi8TBZVe1WHKjP0Z7FBQ"};